import { AngleBoldDown16 } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import { useSettings } from '@wu/widget-core';

export function Arrow() {
  const { textColor } = useSettings();

  return (
    <Icon
      component={AngleBoldDown16}
      size={12}
      fill={textColor || undefined}
      style={{ margin: '2px 0px 2px -4px' }}
      aria-hidden
    />
  );
}
